/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable no-var */
/* eslint-disable dot-notation */
/* eslint-disable max-len */
/**
 * Gives the component a data shape adapted to the cross component  table.
 */
export function bundleToCcc(component) {
  let lang = window.msizerConfiguration.locale;
  if (lang === "en-WW") {
    lang = "en-GB";
  }

  const getIdValueFromTranslation = (data, id, lang) => {
    let value = "N/A";
    data?.translationData?.forEach((translationDataGroup) => {
      translationDataGroup.catalogue_product.characteristic_group_list.characteristic_group.forEach(
        (characteristicGroup) => {
          characteristicGroup.characteristic_list.characteristic.forEach((characteristic) => {
            if (characteristic.id.endsWith(id)) {
              value = characteristic.valueIds.map((item) => item.translation[lang]).join(", ");
            }
          });
        }
      );
    });
    return value;
  };

  const driveCommunicationInterfaces = [];
  try {
    component?.drive?.translationData?.forEach((translationDataGroup) => {
      translationDataGroup.catalogue_product?.characteristic_group_list?.characteristic_group.forEach(
        (characteristicGroup) => {
          characteristicGroup.characteristic_list?.characteristic.forEach((characteristic) => {
            if (characteristic.id.endsWith("COMMUNICATION_INTERFACE")) {
              characteristic.valueIds.forEach((valueId) => {
                driveCommunicationInterfaces.push(valueId.translation?.[lang]);
              });
            }
          });
        }
      );
    });
  } catch (error) {
    console.log(error);
  }

  let connectorValue;
  try {
    connectorValue =
      component?.motor?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group[0]
        .characteristic_list?.characteristic?.[14]?.valueIds?.[0].translation?.[lang] ||
      component?.motor?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group[1]
        .characteristic_list?.characteristic?.[20]?.valueIds?.[0].translation?.[lang];
  } catch (error) {
    console.log(error);
    connectorValue = "";
  }

  let shaftEndValue;
  try {
    shaftEndValue =
      component?.motor?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group[0]
        .characteristic_list?.characteristic?.[9]?.valueIds?.[0].translation?.[lang] ||
      component?.motor?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group[1]
        .characteristic_list?.characteristic?.[13]?.valueIds?.[0].translation?.[lang];
  } catch (error) {
    console.log(error);
    shaftEndValue = "";
  }

  let nbPhasesValue;
  try {
    nbPhasesValue =
      component?.drive?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group[0]
        .characteristic_list?.characteristic?.[4]?.valueIds?.[0].translation?.[lang];
  } catch (error) {
    console.log(error);
    nbPhasesValue = "";
  }

  let speedFeedbackResolutionValue;
  try {
    speedFeedbackResolutionValue =
      component?.motor?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group[0]
        .characteristic_list?.characteristic?.[11]?.valueIds?.[0].translation?.[lang];
  } catch (error) {
    console.log(error);
    speedFeedbackResolutionValue = "";
  }

  return {
    id: component?.id,
    selected: component?.selected,
    driveReference: component?.drive?.commercialReference,
    motorReference: component?.motor?.commercialReference,
    gearboxReference: component?.gearbox?.commercialReference,
    adaptationKitRef: component?.adaptationKitRef || component?.adaptationKit?.commercialReference,
    motorType: component?.motor?.type,
    nominalTorque: Number(component?.nominalTorque?.toFixed(2)),
    maxTorque: component?.gearbox?.maximumOutputTorque,
    nominalSpeed: Number(component?.nominalSpeed?.toFixed(2)),
    inertiaRatio: Number(component?.inertia?.toFixed(2)),
    motorLength: component?.motor?.length,
    flangeSize: component?.motor?.flangeSize,
    shaftEnd: shaftEndValue,
    ipProtections: component?.motor?.ipProtections,
    holdingBrake: component?.motor?.brake ? "Yes" : "No",
    // motorEncoder:
    //   component?.motor?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group?.[1]
    //     .characteristic_list?.characteristic?.[10]?.valueIds?.[0].translation?.[lang],
    motorEncoder:
      getIdValueFromTranslation(component.motor, "D_ENCODER_TYPE", lang) !== "N/A"
        ? getIdValueFromTranslation(component.motor, "D_ENCODER_TYPE", lang)
        : getIdValueFromTranslation(component.motor, "D_FEEDBACK_TYPE", lang),
    connector: connectorValue,
    gearboxManufacturer: "Schneider Electric",
    gearboxType:
      component?.gearbox?.translationData?.[0]?.catalogue_product?.characteristic_group_list?.characteristic_group?.[0]
        .characteristic_list?.characteristic?.[2]?.valueIds?.[0]?.translation?.[lang],
    gearboxRatio: component?.gearbox?.reductionRatio,
    gearboxFamily: component?.gearbox?.family,
    precision: "-",
    specification: "-",
    length: component?.length,
    driveType: component?.drive?.type,
    interface: driveCommunicationInterfaces,
    current: component?.continuousOutputCurrent,
    switchingFreq: component?.drive?.switchingFreq,
    format:
      component?.drive?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group[0]
        .characteristic_list?.characteristic?.[3]?.valueIds?.[0].translation?.[lang],
    nominalTorqueOfMotor: component?.nominalTorqueOfMotor,
    continuousStallTorque: component?.motor?.continuousStallTorque,
    peakStallTorque: component?.motor?.peakStallTorque,
    nominalSpeedOfMotor: component?.nominalSpeedOfMotor,
    inertiaMotor: component?.motor?.inertiaMotor,
    inputDiameter: component?.gearbox?.inputDiameter,
    gearboxEfficiency: component?.gearbox?.efficiency,
    gearboxTorsionalBacklash: component?.gearbox?.torsionalBacklash,
    externalDiameter: component?.gearbox?.externalDiameter,
    // new drive attributes
    driveRangeOfProduct: component?.drive?.rangeOfProduct,
    driveComponentType:
      component?.drive?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group[0]
        .characteristic_list?.characteristic?.[1]?.valueIds?.[0].translation?.[lang],
    driveSupplyVoltage: component?.drive?.outputVoltages,
    nbPhases: nbPhasesValue,
    nominalPower: component?.drive?.nominalPower,
    driveNetWeight: component?.drive?.netWeight,
    driveDepth: component?.drive?.depth,
    driveHeight: component?.drive?.height,
    driveWidth: component?.drive?.width,
    lineCurrent: component?.drive?.lineCurrent,
    driveOutputCurrent3SPeak:
      component?.drive?.translationData?.[0]?.catalogue_product?.characteristic_group_list?.characteristic_group[0]
        ?.characteristic_list?.characteristic?.[11]?.valueIds?.[0]?.translation?.[lang] ||
      component?.drive?.translationData?.[0]?.catalogue_product?.characteristic_group_list?.characteristic_group[1]
        ?.characteristic_list?.characteristic?.[6]?.valueIds?.[0]?.translation?.[lang],
    // new motor attributes
    motorComponentType:
      component?.motor?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group[0]
        .characteristic_list?.characteristic?.[0]?.valueIds?.[0].translation?.[lang],
    numberOfStacks: component?.motor?.numberOfStacks,
    maximumMechanicalSpeed: component?.motor?.maximumMechanicalSpeed,
    motorSupplyVoltage: component?.supplyVoltage,
    shaftDiameter: component?.motor?.shaftDiameter,
    shaftLength: component?.motor?.shaftLength,
    motorWeight: component?.motor?.productWeight,
    continuousStallCurrent: component?.motor?.continuousStallCurrent,
    speedFeedbackResolution: speedFeedbackResolutionValue,
    motorOutputCurrent3SPeak: component?.motor?.outputCurrent3SPeak,
    // new gearbox attributes
    gearboxComponentType:
      component?.gearbox?.translationData?.[0].catalogue_product?.characteristic_group_list?.characteristic_group[0]
        .characteristic_list?.characteristic?.[1]?.valueIds?.[0].translation?.[lang],
    shaftMomentOfInertia: component?.gearbox?.shaftMomentOfInertia,
    gearboxNetWeight: component?.gearbox?.productWeight,
    continuousOutputTorque: component?.gearbox?.continuousOutputTorque,
    maximumOutputTorque: component?.gearbox?.maximumOutputTorque,
    gearboxIpDegreeOfProtection: component?.gearbox?.ipDegreeOfProtection,
    gearboxLength: component?.gearbox?.gearboxLength,
    // new adaptation kit attributes
    adaptationKitComponentType:
      component?.adaptationKit?.translationData?.[0].catalogue_product?.characteristic_group_list
        ?.characteristic_group[0].characteristic_list?.characteristic?.[1]?.valueIds?.[0].translation?.[lang],
    separatePartDestination:
      component?.adaptationKit?.translationData?.[0].catalogue_product?.characteristic_group_list
        ?.characteristic_group[0].characteristic_list?.characteristic?.[5]?.valueIds?.[0].translation?.[lang],
    adaptationKitLength: component?.adaptationKit?.length,
    PRODUCT_CODE: component?.integratedDrive?.extras?.codification,
    T_COMMUNICATION_INTERFACE:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[0]?.characteristics?.filter(
        (c) => c.id === "T_COMMUNICATION_INTERFACE"
      )[0]?.values?.[0]?.value,
    TC_VOLTAGE:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[0]?.characteristics?.filter(
        (c) => c.id === "TC_VOLTAGE"
      )[0]?.values?.[0]?.value,
    T_OFFER_TYPE:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[1]?.characteristics?.filter(
        (c) => c.id === "T_OFFER_TYPE"
      )[0]?.values?.[0]?.value,
    T_ENCODER_TYPE:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[1]?.characteristics?.filter(
        (c) => c.id === "T_ENCODER_TYPE"
      )[0]?.values?.[0]?.value,
    T_NUMBER_OF_MOTOR_STACKS:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[1]?.characteristics?.filter(
        (c) => c.id === "T_NUMBER_OF_MOTOR_STACKS"
      )[0]?.values?.[0]?.value,
    T_SHAFT_TYPE:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[1]?.characteristics?.filter(
        (c) => c.id === "T_SHAFT_TYPE"
      )[0]?.values?.[0]?.value,
    T_MOTOR_FLANGE_SIZE:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[1]?.characteristics?.filter(
        (c) => c.id === "T_MOTOR_FLANGE_SIZE"
      )[0]?.values?.[0]?.value,
    T_HOLDING_BRAKE:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[1]?.characteristics?.filter(
        (c) => c.id === "T_HOLDING_BRAKE"
      )[0]?.values?.[0]?.value,
    TC_LENGTH:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[1]?.characteristics?.filter(
        (c) => c.id === "TC_LENGTH"
      )[0]?.values?.[0]?.value,
    TC_NOMINAL_SPEED:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[1]?.characteristics?.filter(
        (c) => c.id === "TC_NOMINAL_SPEED"
      )[0]?.values?.[0]?.value,
    TC_NOMINAL_TORQUE:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[1]?.characteristics?.filter(
        (c) => c.id === "TC_NOMINAL_TORQUE"
      )[0]?.values?.[0]?.value,
    TASHAFT_TYPE:
      component?.integratedDrive?.extras?.characteristicsSummary?.[0]?.characteristicGroups?.[1]?.characteristics?.filter(
        (c) => c.id === "TASHAFT_TYPE"
      )[0]?.values?.[0]?.value
  };
}

/**
 * Formats all the bundles conveniently for cross component table.
 */
export function bundlesToCccs(components) {
  if (!components) {
    return [];
  }
  const cccs = components.map((bundle) => bundleToCcc(bundle));
  return cccs;
}

/**
 * Formats bundle data for the comparison carousel.
 */
export function bundleToCarouselComponent(bundle) {
  return {
    name: `${bundle.motor.commercialReference} - ${bundle.drive.commercialReference}${
      bundle.gearbox?.commercialReference ? ` - ${bundle.gearbox.commercialReference}` : ""
    }`,
    key: bundle.id,
    selected: bundle.selected,
    gear: {
      name: bundle.gearbox?.commercialReference,
      manufacturer: "Schneider electric",
      family: bundle.gearbox?.family,
      model: bundle.gearbox?.commercialReference,
      nbStages: 0,
      ratio: bundle.gearbox?.reductionRatio,
      clampingHubDiameter: 0
    },
    motor: bundle.motor,
    drive: {
      commercialReference: bundle.drive.commercialReference,
      type: bundle.drive.type
    },
    mainResults: {
      peakMainCurrent: 0,
      continuousMainCurrent: 0,
      apparentMainPower: 0,
      effectiveMainPower: 0
    },
    dcBusResults: {
      peakDcBusCurrent: {
        requiredByApplication: 0,
        providedByHardware: 0,
        externallyNeeded: 0
      },
      ratedDcBusCurrent: {
        requiredByApplication: 0,
        providedByHardware: 0,
        externallyNeeded: 0
      },
      brakingPower: {
        requiredByApplication: 0,
        providedByHardware: 0,
        externallyNeeded: 0
      },
      effectiveMainPower: {
        requiredByApplication: 0,
        providedByHardware: 0,
        externallyNeeded: 0
      }
    },
    nominalSpeedOfMotor: bundle.nominalSpeedOfMotor,
    nominalTorqueOfMotor: bundle.nominalTorqueOfMotor,
    torqueOverSpeed: "-",
    torqueOverTime: "-",
    driveEnvironment: "-",
    MotorEnvironment: "-"
  };
}

/**
 * Formats the bundle data for the component carousel.
 * All bundles of the list are conveniently formatted.
 */
export function bundlesToCarouselComponents(bundles) {
  if (!bundles) {
    return [];
  }
  const cComponents = bundles.map((bundle) => bundleToCarouselComponent(bundle));
  return cComponents;
}
